import { createBrowserRouter, Navigate } from 'react-router-dom'
import { AppLayout } from './components/AppLayout'
import { ProtectedRoute } from './components/ProtectedRoute'
import { ErrorBoundary } from './components/ErrorBoundary'
import { LoginPage } from './pages/LoginPage'
import { RegisterPage } from './pages/RegisterPage'
import { PublicFormPage } from './pages/PublicFormPage'
import { AdminCompaniesPage } from './pages/AdminCompaniesPage'
import { CaseListPage } from './pages/CaseListPage'
import { CaseDetailPage } from './pages/CaseDetailPage'
import { SubcontractorsPage } from './pages/SubcontractorsPage'
import { SearchPage } from './pages/SearchPage'
import { DashboardPage } from './pages/DashboardPage'
import { SettingsPage } from './pages/SettingsPage'
import { TechnicianProfilePage } from './pages/TechnicianProfilePage'
import { SubcontractorProfilePage } from './pages/SubcontractorProfilePage'
import { HelpPage } from './pages/HelpPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { LandingPage } from './marketing/LandingPage'
import { TermsPage, PrivacyPage } from './marketing/legal'

// All routes hang off a pathless root so any render/loader error bubbles to a
// single ErrorBoundary instead of white-screening.
export const router = createBrowserRouter([
  {
    errorElement: <ErrorBoundary />,
    children: [
      { path: '/', element: <LandingPage /> },
      { path: '/terms', element: <TermsPage /> },
      { path: '/privacy', element: <PrivacyPage /> },

      // Public (no auth)
      { path: '/login', element: <LoginPage /> },
      { path: '/register', element: <RegisterPage /> },
      { path: '/f/:formToken', element: <PublicFormPage /> },
      { path: '/f/:formToken/t/:techId', element: <PublicFormPage /> },

      // Company portal (auth required; company roles only)
      {
        path: '/app',
        element: (
          <ProtectedRoute roles={['company_admin', 'company_user']}>
            <AppLayout scope="company" />
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <Navigate to="dashboard" replace /> },
          { path: 'dashboard', element: <DashboardPage /> },
          { path: 'open', element: <CaseListPage status="open" /> },
          { path: 'in-progress', element: <CaseListPage status="in_progress" /> },
          { path: 'closed', element: <CaseListPage status="closed" /> },
          { path: 'cases', element: <CaseListPage status="all" /> },
          { path: 'cases/:caseId', element: <CaseDetailPage /> },
          { path: 'subcontractors', element: <SubcontractorsPage /> },
          { path: 'subcontractors/:id', element: <SubcontractorProfilePage /> },
          { path: 'technicians/:id', element: <TechnicianProfilePage /> },
          { path: 'search', element: <SearchPage /> },
          { path: 'settings', element: <SettingsPage /> },
          { path: 'help', element: <HelpPage /> },
        ],
      },

      // Admin portal (super_admin)
      {
        path: '/admin',
        element: (
          <ProtectedRoute roles={['super_admin']}>
            <AppLayout scope="admin" />
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <AdminCompaniesPage /> },
          { path: 'help', element: <HelpPage /> },
        ],
      },

      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
